module.exports = __webpack_public_path__ + "static/team-impulse-hype-preview-620e9953794a773f2decfb7dfb4b5a3b.mp4";